var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUy = function SvgIconUy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 8.869h11.587a12 12 0 0 0-1.348-3.13H12z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#338AF3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.53 21.39h14.94a12 12 0 0 0 2.768-3.13H1.761a12 12 0 0 0 2.769 3.13M12-.001v2.609h7.47A11.95 11.95 0 0 0 12-.001"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M12 8.869h11.587a12 12 0 0 0-1.348-3.13H12zM0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m10.435 7.023-1.466.69.78 1.419-1.59-.304-.202 1.607-1.109-1.182-1.108 1.182-.202-1.607-1.591.304.78-1.42-1.465-.689 1.465-.69-.78-1.418 1.591.304.202-1.608 1.108 1.183L7.957 3.61l.201 1.608 1.592-.304-.78 1.419z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconUy;